import type { AppModule } from '@ohmybible/core';

import * as routes from './routes';

export const HomeModule: AppModule = {
  routes,
};
